import React from 'react';
import { Box, Typography, Button, Stack, LinearProgress } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import lukyMaintenance from '../assets/luky-maintenance.png';
import { LukaLogoIcon } from '../components/onboarding-icons';

interface MaintenancePageProps {
  onRetry?: () => void;
}

const MaintenancePage: React.FC<MaintenancePageProps> = ({ onRetry }) => {
  const [isRetrying, setIsRetrying] = React.useState(false);
  
  const handleRetry = async () => {
    setIsRetrying(true);
    // Pequeño delay visual
    await new Promise(r => setTimeout(r, 1500));
    onRetry?.();
    setIsRetrying(false);
  };

  return (
    <>
      <Helmet>
        <title>Mantenimiento - LukaPay</title>
        <link rel="icon" href="/favicon.png" type="image/png" />
      </Helmet>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 3,
          bgcolor: '#FFFFFF'
        }}
      >
        <Stack spacing={3} alignItems="center" maxWidth={500}>
          {/* Logo Luka */}
          <Box sx={{ mb: 1 }}>
            <LukaLogoIcon style={{ width: 120, height: 'auto' }} />
          </Box>

          {/* Ilustración de Luky arreglándose */}
          <Box
            component="img"
            src={lukyMaintenance}
            alt="Luky en mantenimiento"
            sx={{
              width: { xs: 200, sm: 280 },
              height: 'auto',
            }}
          />

          {/* Mensaje principal */}
          <Typography
            variant="h5"
            fontWeight="700"
            textAlign="center"
            color="text.primary"
          >
            Portal en mantenimiento
          </Typography>
          
          <Typography
            variant="body1"
            color="text.secondary"
            textAlign="center"
            sx={{ maxWidth: 420 }}
          >
            El Portal se encuentra temporalmente fuera de servicio por tareas de mantenimiento y actualización. El acceso será restablecido en breve.
          </Typography>

          {/* Barra de progreso animada */}
          {isRetrying && (
            <Box sx={{ width: '100%', maxWidth: 300 }}>
              <LinearProgress color="primary" />
            </Box>
          )}

          {/* Botón de reintentar */}
          <Button
            variant="contained"
            size="large"
            onClick={handleRetry}
            disabled={isRetrying}
            sx={{
              mt: 2,
              px: 4,
              py: 1.5,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 600
            }}
          >
            {isRetrying ? 'Verificando...' : 'Intentar de nuevo'}
          </Button>

          {/* Mensaje secundario */}
          <Typography
            variant="caption"
            color="text.disabled"
            textAlign="center"
          >
            Si el problema persiste, intenta recargar la página en unos minutos
          </Typography>
        </Stack>
      </Box>
    </>
  );
};

export default MaintenancePage;
